<template>
		<v-menu
			ref="projectTypeSelectMenu"
			offset-y
			offset-x
			left
			:close-on-content-click="false"
			max-width="500"
			min-width="500"
			content-class="menu-bg-white"
			style="z-index: 9999; background-color: white;">
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					icon
					color="warning"
					x-small
					:disabled="isDisabled"
					v-bind="attrs"
					v-on="on"
				>
					<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
				</v-btn>
			</template>
			<v-list dense class="py-0" max-height="400" style="z-index: 9999;background-color: white;">
				<v-list-item dense style="min-height: 25px; background: #524D4D">
					<div class="d-flex align-center justify-space-between my-1" style="width: 100%">
						<p class="caption mb-0 font-weight-bold white--text">Cambiar Tipo de Proyecto</p>
						<div>
							<v-text-field
								v-model="searchProjectTypeInput"
								outlined
								dense
								hide-details
								label="Búsqueda"
								class="custom-height-search custom-height-calendar"
								dark
								color="white"
							></v-text-field>
						</div>
					</div>
				</v-list-item>
				<v-list-item-group color="#524D4D" v-for="category in companiesProjectTypesCategories" :key="'pt_'+category.id">
					<v-subheader class="grey lighten-2 black--text font-weight-bold">{{ category.name }}</v-subheader>
					<v-list-item
						v-for="(project_type, index) in category.project_types"
						:key="index"
						dense
						@click.stop="projectTypeChange(project_type)"
					>
						<v-list-item-content>
							<v-list-item-title dense>
								<div class="d-flex align-center justify-space-between">
									{{ project_type.name }}
									<v-btn
										text
										small
										v-if="project_type.sub_types?.length > 0"
										@click.stop="handleOpenSubTypes(project_type)"
									>
										<div class="d-flex align-center justify-space-between">
											<p class="mb-0 caption text--disabled">Subtipos</p>
											<v-icon dark v-if="hideSubTypes.includes(project_type.id)">mdi-chevron-up</v-icon>
											<v-icon dark v-else>mdi-chevron-down</v-icon>
										</div>
									</v-btn>
								</div>
							</v-list-item-title>
							<v-list-item
								v-for="(sub_type, index) in project_type.sub_types"
								:key="index"
								v-show="hideSubTypes.includes(project_type.id)"
								dense
								@click.stop="projectTypeChange(sub_type)"
							>
								<v-list-item-content>
									<v-list-item-title dense>
										<p class="text--disabled mb-1" style="font-size: 10px;line-height: 10px">{{ project_type.name }}</p>
										<div class="d-flex align-center justify-space-between">
											{{ sub_type.name }}
										</div>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-item-content>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</v-menu>
</template>

<script>
export default {
	name: "ProjectTypeSelectorMenu",
	props: {
		onClick: {
			type: Function,
			required: true
		},
		isDisabled: {
			type: Boolean,
			default: false
		}
	},
	data(){
		return {
			searchProjectTypeInput: null,
			hideSubTypes: []
		}
	},
	computed: {
		companiesProjectTypesCategories() {
			const search = this.searchProjectTypeInput?.trim().toLowerCase();
			if (search) {
					return this.$store.state.companies.companiesProjectTypesCategories
							.map(category => {
									const filteredProjectTypes = category.project_types
											.map(pt => {
													const hasMatch = pt.name.toLowerCase().includes(search);
													const filteredSubTypes = pt.sub_types?.filter(st =>
															st.name.toLowerCase().includes(search)
													) || [];
													if (hasMatch || filteredSubTypes.length > 0) {
															return {
																	...pt,
																	sub_types: filteredSubTypes
															};
													}
													return null;
											})
											.filter(Boolean);
									if (filteredProjectTypes.length > 0) {
											return {
													...category,
													project_types: filteredProjectTypes
											};
									}
									return null;
							})
							.filter(Boolean);
			}
			return this.$store.state.companies.companiesProjectTypesCategories;
		},
	},
	methods: {
		handleOpenSubTypes(project_type) {
			this.hideSubTypes = this.hideSubTypes.includes(project_type.id)
					? this.hideSubTypes.filter(id => id !== project_type.id)
					: [...this.hideSubTypes, project_type.id];
		},
		projectTypeChange(project_type) {
			if(project_type.sub_types?.length){
				this.handleOpenSubTypes(project_type)
			}
			else{
				this.$refs.projectTypeSelectMenu.isActive = false
				this.onClick(project_type)
			}
		}
	}
}
</script>